import { render, staticRenderFns } from "./SortableField.vue?vue&type=template&id=699743c8&scoped=true&"
import script from "./SortableField.vue?vue&type=script&lang=ts&"
export * from "./SortableField.vue?vue&type=script&lang=ts&"
import style0 from "./SortableField.vue?vue&type=style&index=0&id=699743c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699743c8",
  null
  
)

export default component.exports